import { showDeleteErrorModal } from '../actions/viewActions';
import ConnectionsCRUDActions from '../actions/ConnectionsCRUDActions';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';
import { getErrorJson } from '@mm/utils';

// Should this one fall back to common error handler?
export const connectionErrorHandler =
  (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, facebookPageId: number) => {
    if (error instanceof Response && error.status === UNPROCESSABLE_ENTITY) {
      const parsed = await getErrorJson(error);
      dispatch(showDeleteErrorModal(parsed.errors));
      dispatch(ConnectionsCRUDActions.retrieveAll(facebookPageId));
      dispatch(
        ConnectionsCRUDActions.retrieveAll(facebookPageId, {
          type: 'google_spreadsheets',
          pageSize: 99999,
        }),
      );
      dispatch(ConnectionsCRUDActions.unbusy());
    } else {
      commonHandler(dispatch)(error);
      throw error;
    }
  };
